module.exports = __webpack_public_path__ + "static/enza-web-2e4cdf9b58a31dbc2528f1605c7dfa4e.jpg";